export const FOUR_COLUMN = '25%'
export const THREE_COLUMN = '33%'
export const TWO_COLUMN = '50%'
export const ONE_COLUMN = '100%'

export const RECOMMENDED_PRODUCTS_MINIMUM_COUNT = 3
